// extracted by mini-css-extract-plugin
module.exports = {"root":"FavoritePackageTooltip_root__55Pqz","tooltipVisible":"FavoritePackageTooltip_tooltipVisible__3aSz7"};